import { create } from 'zustand';
import { ISiteInfoType, siteInfoInitialValues } from '@components/lms/addNewSite/components/siteInformation';
import { IMeetingDetailsType, meetingDetailsInitialValues } from '@components/lms/addNewSite/components/meetingDetails';
import { IGlueDetailsType, glueDetailsInitialValues } from '@components/lms/addNewSite/components/glueDetails';
import { IOtherInfoType, otherInfoInitialValues } from '@components/lms/addNewSite/components/otherInformation';

interface ILmsAddNewSiteStore {
	siteInfo: ISiteInfoType;
	meetingDetails: IMeetingDetailsType;
	glueDetails: IGlueDetailsType;
	otherInfo: IOtherInfoType;
	appIdC: string;
	endUserC: string;
	membershipNo: string;
	typeOfContracts: string;
	noOfSites: string;
	contractorPotentialPerMonth: string;

	setKeyBaseValue: <T>(key: string, value: T) => void;
	setSubKeyValue: (key: string, subKey: string, value: unknown) => void;
	resetAddNewSiteValues: () => void;
}

const initialState = {
	siteInfo: { ...siteInfoInitialValues },
	meetingDetails: { ...meetingDetailsInitialValues },
	glueDetails: { ...glueDetailsInitialValues },
	otherInfo: { ...otherInfoInitialValues },
	appIdC: '',
	endUserC: '',
	membershipNo: '',
	typeOfContracts: '',
	noOfSites: '',
	contractorPotentialPerMonth: '',
};

export const useAddNewSiteStore = create<ILmsAddNewSiteStore>((set) => ({
	...initialState,

	setKeyBaseValue: <T,>(key: string, value: T): void =>
		set((state) => ({
			...state,
			[key]: value,
		})),

	setSubKeyValue: (key: string, subKey: string, value: unknown): void =>
		set((state) => ({
			...state,
			[key]: {
				...state[key],
				[subKey]: value,
			},
		})),
	resetAddNewSiteValues: (): void => set(initialState),
}));
